Namespace 'Monitoring.Reports.Publications'

class Monitoring.Reports.Publications.HeaderView extends Backbone.View
  
  className: 'header'
  template: JST['backbone/templates/monitoring/reports/publications/header']

  events:
    'click #options': 'toggle_options'
    'click #comments-metrics-active': 'commentsMetricsOptionsChanged'

  initialize: (@options = {}) ->
    # just set @options

  render: ->
    @$el.html(@template(@options))
    @granularity_options = new Monitoring.Reports.Publications.ReportGranularityView(@options.date_since, @options.date_until)
    @$('#granularity-options').append(@granularity_options.render().el)
    @page_granularity_options = new Monitoring.Reports.Publications.ReportGranularityView(@options.page_date_since, @options.page_date_until)
    @$('#page-granularity-options').append(@page_granularity_options.render().el)
    @fill_custom_options_section(@options.available_sections)
    return this

  fill_custom_options_section:(available_sections) =>
    for section in available_sections
      options_view = new Monitoring.Reports.Publications.Sections.OptionsView(section)
      @$('#options-table tr:last').after(options_view.render().$el.html());


  toggle_options: =>
    button = @$('#options')
    button.toggleClass('opened')
    button.find('.arrow').toggleClass('fa-chevron-right').toggleClass('fa-chevron-down')
    if button.hasClass('opened')
      @$('.report-extra-settings').css('display', 'block')
    else
      @$('.report-extra-settings').css('display', 'none')

  rankings_config: ->
    selectedRankingTitles = (input.value for input in @$('.rankings input') when input.checked)
    ranking for ranking in @options.rankings when ranking.title in selectedRankingTitles

  has_summary_section:->
    $('#show_summary_section')[0].checked

  has_comments_metrics: ->
    $('#comments-metrics-active')[0].checked

  has_page_metrics:->
    $('#show_page_reach_evolution')[0].checked ||  $('#show_page_fans_evolution')[0].checked

  include_page_reach_evolution: ->
    $('#show_page_reach_evolution')[0].checked

  include_page_fans_evolution: ->
    $('#show_page_fans_evolution')[0].checked
      
  include_comment_replies: ->
    $('#include-comment-replies')[0].checked

  include_sentiment_metrics_chart: ->
    $('#include-sentiment-metrics-chart')[0].checked

  include_comments_sentiment_metrics: ->
    $('#include-comments-sentiment-metrics')[0].checked

  include_page_resumen: ->
    $('#include_page_resumen')[0].checked

  analysis_date: ->
    @$('#date_until').val()

  getSelectedSections:() ->
    @selectedSections()

  getSelectedSubsections: (section_title) ->
    @selectedSubsections(section_title)


  commentsMetricsOptionsChanged: ->
    @$('.comment-subsection').show() if @has_comments_metrics()
    @$('.comment-subsection').hide() if !@has_comments_metrics()

  selectedSections: ()->
    selected = []
    sections_ids = @available_sections_keys()
    for hash in sections_ids
      section_id = _.keys(hash)[0]
      if $('#'+section_id)[0].checked
        selected.push(hash)
    selected

  selectedOnly: (subsections) ->
    selecteds = []
    for hash in subsections
      section_id = _.keys(hash)[0]
      if $('#'+section_id)[0].checked
        selecteds.push(hash)
    selecteds


  selectedSubsections: (section_title)->
    subsections = @available_subsections_keys()[section_title]
    @selectedOnly(subsections)
    
  available_subsections_keys: ()->
    {tematicas_y_reclamos: [{thematics: Monitoring.Reports.Publications.Subsections.ThematicsView},{complaints: Monitoring.Reports.Publications.Subsections.ComplaintsView}] }


  available_sections_keys: ()->
    [tematicas_y_reclamos: Monitoring.Reports.Publications.Sections.ThematicsAndComplaintsSectionView]

  getDateFrom: () ->
    @_formatDate(@_analysisDate().dateFrom, @granularity_options.getAnalysisTimezone())

  getDateTo: () ->
    @_formatDate(@_analysisDate().dateTo, @granularity_options.getAnalysisTimezone())

  getPageDateFrom: () ->
    @_formatDate(@_pageAnalysisDate().dateFrom, @page_granularity_options.getAnalysisTimezone())

  getPageDateTo: () ->
    @_formatDate(@_pageAnalysisDate().dateTo, @page_granularity_options.getAnalysisTimezone())

  getDimension: () ->
    @_pageAnalysisDate().dimension

  getAnalysisDate: ->
    @_analysisDate()

  _analysisDate: () ->
    @granularity_options.getAnalysisDate()

  _pageAnalysisDate: () ->
    @page_granularity_options.getAnalysisDate()

  _formatDate: (date, timezone) ->
    Date.create("#{date.toDateString()} #{timezone}").toISOString()
